<template>
    <div class="image-card">
        <div class="card">

            <slot name="header">
                <div class="card-header" v-html="header"></div>
            </slot>

            <div class="card-body d-flex flex-column">
                <slot name="body">

                    <div class="d-flex align-items-center justify-content-between pb-2 mb-1 border-bottom-1 border-bottom">
                        <span v-for="(item, iindex) in columns" :key="iindex" class="fw-bold">{{ item }}</span>
                    </div>

                    <ul v-if="items.length" class="list-none p-0 m-0">
                        <li v-for="(item, iindex) in items" :key="iindex" class="d-flex align-items-center justify-content-between py-1">
                            <span>{{ item.title }}</span>
                            <div class="p-avatar-group p-component w-8rem justify-content-evenly">
                                <!-- <div v-for="(image, pindex) in item.images" :key="pindex" class="p-avatar p-component p-avatar-image p-avatar-circle">
                                    <img :src="image" />
                                </div> -->
                                <AvatarGroup v-if="items.length">
                                    <Avatar v-for="(image, pindex) in item.images.slice(0, 4)" :key="pindex" :image="image" shape="circle" />
                                    <Avatar v-if="item.images.length > 4" :label="`+${(item.images.length - 4)}`" shape="circle" />
                                </AvatarGroup>
                            </div>
                        </li>
                    </ul>

                </slot>
            </div>

            <slot name="footer">
                <div class="card-footer" v-html="footer"></div>
            </slot>

        </div>
    </div>
</template>


<script>
    import AvatarGroup from 'primevue/avatargroup';
    import Avatar from 'primevue/avatar';

    export default {
        name: "GroupCard",
        components: {
            AvatarGroup,
            Avatar,
        },
        props: {
            header: {
                type: String,
                default: "",
            },
            image: {
                type: String,
                default: "",
            },
            columns: {
                type: Array,
                default() {
                    return [];
                },
            },
            items: {
                type: Array,
                default() {
                    return [];
                },
            },
            footer: {
                type: String,
                default: "",
            },
        },
        setup() {
            return {};
        },
    };
</script>


<style lang="scss">
    .image-card {
        width: 100%;
        height: 100%;

        a {
            text-decoration: underline;
        }

        .list-none {
            list-style: none;
        }

        .card {
            border: 0px;
            border-radius: 10px;
            padding: 10px;
            height: 100%;
            width: 100%;
        }
        .card-header {
            background-color: unset;
            border: 0px;
            font-size: 1rem;
            font-weight: 600;
        }
        .card-footer {
            background-color: unset;
            border: 0px;
        }
    }
</style>